import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import { API_BASE } from "../config";
export default function PowerUsers() {
  const [users, setUsers] = useState([]);
  const [editingUser, setEditingUser] = useState(null);
  const [searchText, setSearchText] = useState("");
  const customStyles = {
    headCells: {
      style: {
        justifyContent: "center", // center header
        textAlign: "center",
        fontWeight: "bold",       // bold text
        fontSize: "16px",   
      },
    },
    cells: {
      style: {
        justifyContent: "center", // center isi cell
        textAlign: "center",
      },
    },
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = () => {
    fetch(`${API_BASE}/api/power/users`)
      .then((res) => res.json())
      .then((data) => setUsers(data))
      .catch((err) => console.error("❌ Gagal ambil users:", err));
  };

  const handleSave = (user) => {
    fetch(`${API_BASE}/api/power/users/${user.id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        status: user.status,
        can_power_on: user.can_power_on,
        can_power_off: user.can_power_off,
      }),
    })
      .then((res) => res.json())
      .then(() => {
        // update users state langsung dari editingUser
        setUsers((prev) =>
          prev.map((u) =>
            u.id === user.id
              ? {
                  ...u,
                  status: user.status,
                  can_power_on: user.can_power_on,
                  can_power_off: user.can_power_off,
                }
              : u
          )
        );

        setEditingUser(null);

        Swal.fire("Berhasil", `User ${user.name} diperbarui`, "success");
      })
      .catch((err) => {
        console.error("❌ Gagal update user:", err);
        Swal.fire("Error", "Gagal update user", "error");
      });
  };

  const filteredUsers = users.filter(
    (u) =>
      u.name.toLowerCase().includes(searchText.toLowerCase()) ||
      u.card.toLowerCase().includes(searchText.toLowerCase())
  );

  const columns = [
    { name: "No", selector: (row, i) => i + 1, width: "60px" },
    { name: "Name", selector: (row) => row.name, sortable: true },
    { name: "Card ID", selector: (row) => row.card, sortable: true },
    {
      name: "Active",
      cell: (row) =>
        editingUser?.id === row.id ? (
          <select
            value={editingUser.status}
            onChange={(e) =>
              setEditingUser({ ...editingUser, status: e.target.value })
            }
            className="border p-1 rounded w-28 text-center"
          >
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        ) : row.status === "active" ? (
          <span className="px-3 py-1 rounded-lg text-white bg-green-500 text-sm">
            Active
          </span>
        ) : (
          <span className="px-3 py-1 rounded-lg text-white bg-gray-400 text-sm">
            Inactive
          </span>
        ),
    },
    {
      name: "ON",
      cell: (row) =>
        editingUser?.id === row.id ? (
          <select
            value={editingUser.can_power_on}
            onChange={(e) =>
              setEditingUser({
                ...editingUser,
                can_power_on: parseInt(e.target.value),
              })
            }
            className="border p-1 rounded w-20 text-center"
          >
            <option value={1}>True</option>
            <option value={0}>False</option>
          </select>
        ) : row.can_power_on ? (
          "True"
        ) : (
          "False"
        ),
    },
    {
      name: "OFF",
      cell: (row) =>
        editingUser?.id === row.id ? (
          <select
            value={editingUser.can_power_off}
            onChange={(e) =>
              setEditingUser({
                ...editingUser,
                can_power_off: parseInt(e.target.value),
              })
            }
            className="border p-1 rounded w-20 text-center"
          >
            <option value={1}>True</option>
            <option value={0}>False</option>
          </select>
        ) : row.can_power_off ? (
          "True"
        ) : (
          "False"
        ),
    },
    {
      name: "Action",
      cell: (row) =>
        editingUser?.id === row.id ? (
          <div className="flex gap-2 justify-center">
            <button
              onClick={() => handleSave(editingUser)}
              className="bg-green-500 text-white px-3 py-1 rounded"
            >
              Save
            </button>
            <button
              onClick={() => setEditingUser(null)}
              className="bg-gray-400 text-white px-3 py-1 rounded"
            >
              Cancel
            </button>
          </div>
        ) : (
          <button
            onClick={() => setEditingUser(row)}
            className="bg-blue-500 text-white px-3 py-1 rounded"
          >
            Edit
          </button>
        ),
    },
  ];

  return (
  <div className="p-2">
      <h2 className="text-2xl font-bold mb-4 text-center">Manage Power Users</h2>
      
      {/* Search input */}
      <div className="mb-4 flex justify-end">
        <input
          type="text"
          placeholder="🔍 Search Name or Card ID..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          className="border p-2 rounded w-64"
        />
        {searchText && (
          <button
            onClick={() => setSearchText("")}
            className="ml-2 px-3 py-1 bg-gray-300 rounded"
          >
            Clear
          </button>
        )}
      </div>

      <DataTable
        columns={columns}
        data={filteredUsers}
        pagination
        highlightOnHover
        responsive
        customStyles={customStyles}

      />
    </div>
  );
}
